__turbopack_context__.v({
  "BrightBlue": "Button-module-sass-module__yk0_hG__BrightBlue",
  "Button": "Button-module-sass-module__yk0_hG__Button",
  "DeepNavy": "Button-module-sass-module__yk0_hG__DeepNavy",
  "Inverted": "Button-module-sass-module__yk0_hG__Inverted",
  "Loading": "Button-module-sass-module__yk0_hG__Loading",
  "NoBorder": "Button-module-sass-module__yk0_hG__NoBorder",
  "SkyBlue": "Button-module-sass-module__yk0_hG__SkyBlue",
  "Small": "Button-module-sass-module__yk0_hG__Small",
  "Transparent": "Button-module-sass-module__yk0_hG__Transparent",
});
